module.exports = __webpack_public_path__ + "img/gebrateneudonmithintergrund.dd102ef7.jpg";